import type { ThumbOp } from './thumbnail';

const BACKGROUND = '#f6f3ee';
const NEUTRAL = '#d9d4cc';

/** A thumbnail plan (640 × 400) drawn in SVG, images as plain tiles: template and page previews (P10, P14). */
export function ThumbOpsSvg({ ops, className, ...data }: { ops: readonly ThumbOp[]; className?: string } & Record<`data-${string}`, string>) {
  return (
    <svg viewBox="0 0 640 400" role="presentation" className={className} {...data}>
      <rect x={0} y={0} width={640} height={400} fill={BACKGROUND} />
      {ops.map((op, i) =>
        op.kind === 'ellipse' ? (
          <ellipse key={i} cx={op.x + op.w / 2} cy={op.y + op.h / 2} rx={op.w / 2} ry={op.h / 2} fill={op.fill ?? NEUTRAL} />
        ) : op.kind === 'line' ? (
          <polyline key={i} points={(op.points ?? []).map((p) => `${p.x},${p.y}`).join(' ')} fill="none" stroke={op.fill} />
        ) : op.kind === 'text' ? (
          <rect key={i} x={op.x} y={op.y + op.h / 3} width={op.w * 0.8} height={Math.max(1, op.h / 3)} fill={op.fill} />
        ) : (
          <rect key={i} x={op.x} y={op.y} width={op.w} height={op.h} fill={op.fill ?? NEUTRAL} stroke={NEUTRAL} strokeWidth={0.5} />
        ),
      )}
    </svg>
  );
}
